import types from './types';

const getEventsRequest = (start, end) => ({
  type: types.GET_EVENTS_REQUEST,
  start,
  end
});

const getEventsSuccess = (
  all,
  events,
  birthdays,
  monthYear
) => ({
  type: types.GET_EVENTS_SUCCESS,
  all,
  events,
  birthdays,
  monthYear
});

const getEventsFailure = error => ({
  type: types.GET_EVENTS_FAILURE,
  error: error.message
});

/**
 * Create a new event or update an existing one
 * @param {Number} id - Id of event. If event is new, this will be null
 * @param {String} title - Title of event
 * @param {String} location - Location of event
 * @param {String} date - Date of event (ISO string)
 * @param {String} startTime - Start time of event (ISO string)
 * @param {String} endTime - End time of event (ISO string) *
 * @param {String} description - Description of event
 * @param {Boolean} allDay - Is the event an all day event
 */
const saveEventRequest = (
  id,
  title,
  location,
  date,
  startTime,
  endTime,
  description,
  allDay
) => ({
  type: types.SAVE_EVENT_REQUEST,
  id,
  title,
  location,
  date,
  startTime,
  endTime,
  description,
  allDay
});

const saveEventSuccess = (event, isExistingEvent) => ({
  type: types.SAVE_EVENT_SUCCESS,
  event,
  isExistingEvent
});

const saveEventFailure = error => ({
  type: types.SAVE_EVENT_FAILURE,
  error: error.message
});

export default {
  getEventsRequest,
  getEventsSuccess,
  getEventsFailure,
  saveEventRequest,
  saveEventSuccess,
  saveEventFailure
};
